import { useEffect, useReducer, useRef } from "react";
import { Subject } from "rxjs";
import { delay, filter, takeUntil, tap } from "rxjs/operators";
import { FormGroup } from "../../..";
export const useFormGroup = () => {
  const [, reRender] = useReducer(x => x + 1, 0);
  const formGroupRef = useRef(new FormGroup({}));
  const setFormGroup$Ref = useRef(new Subject());
  const destroy$Ref = useRef(new Subject());
  const setFormGroupRef = useRef(setFormGroup$Ref.current.next.bind(setFormGroup$Ref.current));
  const getFormGroupRef = useRef(() => formGroupRef.current);
  useEffect(() => {
    setFormGroup$Ref.current.pipe(takeUntil(destroy$Ref.current), filter(formGroup => formGroup !== formGroupRef.current), tap(formGroup => {
      formGroupRef.current = formGroup;
      formGroupRef.current.forceUpdate = reRender;
    }), delay(1), tap(() => {
      reRender();
    })).subscribe();
  }, []);
  return {
    setFormGroup: setFormGroupRef.current,
    getFormGroup: getFormGroupRef.current
  };
};